import { render } from "./OfferIconsInfo.vue?vue&type=template&id=d342c184&scoped=true"
import script from "./OfferIconsInfo.vue?vue&type=script&lang=js"
export * from "./OfferIconsInfo.vue?vue&type=script&lang=js"

import "./OfferIconsInfo.vue?vue&type=style&index=0&id=d342c184&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d342c184"],['__file',"webpack-assets/vue/templates/product/catalog/parts/OfferIconsInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d342c184"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d342c184', __exports__)) {
    api.reload('d342c184', __exports__)
  }
  
  module.hot.accept("./OfferIconsInfo.vue?vue&type=template&id=d342c184&scoped=true", () => {
    api.rerender('d342c184', render)
  })

}


export default __exports__